import { useSelector } from 'react-redux';
import BaseTable from '../../components/BaseTable';
import { fetchSupportLogsListOrEmpty } from '../../api/careRecords';
import { CARE_TABLE_KIND, useTableColumns } from '../../hooks/columns';
import { useCareList } from '../../hooks/useCareList';

export default function SupportLogs() {
  const token = useSelector((state) => state.auth.token);
  const columns = useTableColumns(CARE_TABLE_KIND.supportLogs);
  const { data, loading, error } = useCareList(
    fetchSupportLogsListOrEmpty,
    token
  );

  return (
    <div className="care-page">
      <BaseTable
        columns={columns}
        dataSource={data}
        loading={loading}
        error={error}
        searchKeys={['id', 'staffEmail', 'action']}
        searchPlaceholder="Search log id, staff, action…"
        emptyText="No support logs found."
      />
    </div>
  );
}
